import { type ReactNode, useEffect } from 'react'
import { useBlocker } from 'react-router'
import { useSnapshot } from 'valtio'
import { confirmDayAheadBidTableLeave } from '../../dayAheadBidTableLeave.helper'
import { dayAheadBidTableStore } from '../../store/dayAheadBidTableStore'

export function DayAheadBidTableRouteBlocker(): ReactNode {
  const { hasPendingEdits } = useSnapshot(dayAheadBidTableStore)
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => hasPendingEdits && currentLocation.pathname !== nextLocation.pathname
  )

  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return
    }

    if (confirmDayAheadBidTableLeave('route')) {
      blocker.proceed()
    } else {
      blocker.reset()
    }
  }, [blocker])

  return null
}
